module.exports = __webpack_public_path__ + "e74a4fcd9768619335c6f0b0d5371d72.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1119
// module chunks = 0